import apiClient from "../lib/utils/network-client";

export async function uploadFileToS3(file, folder = "general") {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("folder", folder);

  try {
    const response = await apiClient.post("/uploads", formData);
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      return error.response.data;
    }

    return {
      success: false,
      message: error.message || "Upload failed"
    };
  }
}
